module.exports = __webpack_public_path__ + "hinted-OpenSans-ExtraboldItalic.ce93eb1e6da60b965fd5.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSans-ExtraboldItalic.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSans-ExtraboldItalic.woff
// module chunks = 1